import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceFoodSafetyCertificate } from 'modules/suppliers/types';

// export type FoodSafetyCertificate = typeof schemas.CertificateFromKios._type;
export type FoodSafetyCertificate = ReplaceFoodSafetyCertificate;

interface UseFoodSafetyCertificateProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
}

const useFoodSafetyCertificate = (props: UseFoodSafetyCertificateProps) => {
  const { supplierProfileOperationCode, customerOperationCode } = props;
  const service = useService();

  return useQuery({
    queryKey: ['foodSafetyCertificates'],
    queryFn: async () => {
      try {
        if (!service || !customerOperationCode || !supplierProfileOperationCode) {
          return null;
        }

        const res: FoodSafetyCertificate[] =
          await service.SupplierProfileController_listCertificateBySupplierProfile({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
            },
            queries: {
              supplierProfileOperationCode,
            } as { pageIndex?: number; pageSize?: number; sorts?: string },
          });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useFoodSafetyCertificate;
